/**
 * A key identifying one submission attempt.
 *
 * Sent as `idempotencyKey` on deposit and withdrawal requests. The server
 * treats two requests carrying the same key as the same request and returns
 * the original record instead of creating a second, so the key must stay the
 * same across retries of one submission and change for a genuinely new one.
 *
 * This is a convenience layer. It reduces the number of duplicates that reach
 * the API; it is not what stops them being recorded. That is the server's
 * unique index.
 */
const newIdempotencyKey = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Older Safari, and any non-secure context. Collision risk here is
  // irrelevant: the key is only ever compared against this one user's own
  // recent requests.
  return `k-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
};

export default newIdempotencyKey;
